import {isMacOS} from '@github-ui/get-os'

export const isPlatformMeta = (e: React.MouseEvent | React.KeyboardEvent | PointerEvent): boolean => {
  // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
  return isMacOS() ? e.metaKey : e.ctrlKey
}
